// 📁 components/Settings/IntegrationsPage.jsx

import React from 'react';
import { INTEGRATIONS, MIN_ACTIVE_INTEGRATIONS } from 'config/integrationsConfig';
import ModuleGridPage from '../ModuleGridPage';

const IntegrationsPage = () => (
	<ModuleGridPage
		title='Integrations'
		description='Connect the smart lock platforms that power your organisation. Active integrations sync locks, credentials, and access logs automatically.'
		modules={INTEGRATIONS}
		minActive={MIN_ACTIVE_INTEGRATIONS}
		emptyText='No integrations configured yet.'
	/>
);

export default IntegrationsPage;
